import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticleStartPanelComponent } from './article-start-panel.component';

/**
 * @deprecated
 */
@NgModule({
  declarations: [ArticleStartPanelComponent],
  exports: [ArticleStartPanelComponent],
  imports: [
    CommonModule
  ],
})
export class ArticleStartPanelModule { }
